export { default } from "./useSellerInquirySubmitHandler";
